<template>
  <div v-if="$companyConfiguration.evaluation.isEnabled()">
    <page-heading
      heading="Мои оценки 360"
    >
    </page-heading>

    <el-card>
      <my-evaluations-component
        ref="myEvaluationsComponent"
      ></my-evaluations-component>
    </el-card>
  </div>
</template>

<script>
import MyEvaluationsComponent from "@/modules/evaluation/components/myEvaluation/MyEvaluationsComponent.vue";
import PageHeading from "@/components/PageHeading";
export default {
  name: 'eval-user-evaluations',
  components: {
    MyEvaluationsComponent,
    PageHeading,
  },
  methods: {
    loadEvaluations() {
      if (this.$refs.myEvaluationsComponent) {
        this.$refs.myEvaluationsComponent.loadEvaluations();
      }
    },
  }
}
</script>

<style scoped lang="scss">
  @import "./src/assets/css/project-variables";
</style>